export default {
  fontFamily: '"Slabo 27px", sans-serif',
  headerFontFamily: '"Slabo 27px", sans-serif',
  bodyFontFamily: '"Open Sans", sans-serif',
  pageBackgroundColor: 'white',
  bottomNavigationColor: 'gold',
  topNavigationColor: 'rgba(53,22,9,.767)',
  footerColor: '#000058',
  maxPageContentWidth: '55rem',
  pageTopBleedColor: 'rgba(87, 55, 7, 0.43)',
  pageBreakPointSmall: '45rem',
  linkColor: `#634b41`,
  mobileMenuBackgroundColor: 'white',
  mobileMenuButtonBackgroundNormal: 'gold',
  mobileMenuButtonBackgroundActive: '#ffe776',
  mobileMenuButtonTextNormal: 'black',
  mobileMenuButtonTextActive: '#0000009c',
  mobileMenuTopButtonTextColorNormal: 'white',
  mobileMenuTopButtonTextColorActive: 'white',
  mobileMenuTextColor: '#000058',
  mobileMenuSectionTextColor: '#634b41'
}
